import { ChevronBottomOutlineIcon } from '@ikyucom/design-system-icons-react'
import * as Collapsible from '@radix-ui/react-collapsible'
import clsx from 'clsx'
import { useState } from 'react'
import type { ReactNode } from 'react'
import { css, sva } from '~/styled-system/css'
import { hstack } from '~/styled-system/patterns'
import { Collapsible as CollapsibleComponent } from '~/ui/Collapsible'

type Props = {
  mainContent: ReactNode
  subContent: ReactNode
  isGuide?: boolean
  isPlanModal?: boolean
  className?: string
}

const styles = sva({
  slots: ['container', 'divide'],
  base: {
    container: {
      spaceY: '3',
      _pc: {
        spaceY: '5',
        p: '6',
        backgroundColor: 'gray.100',
        rounded: 'md',
      },
    },
    divide: {
      dsY: '3',
      divideY: 'thin',
      divideColor: 'gray.300',
      divideStyle: 'dashed',
      _pc: {
        divideStyle: 'solid',
        divideColor: 'gray.200',
        dsY: '5',
      },
    },
  },
})

export function RestaurantInfoAccordion({
  mainContent,
  subContent,
  isGuide = true,
  isPlanModal,
  className,
}: Props) {
  const [open, setOpen] = useState(!isGuide)

  const size = isPlanModal ? 'wide' : 'default'
  const title = isGuide ? '店舗情報' : 'この店舗について'

  const classes = styles()

  return (
    <section className={className} id="detail">
      <CollapsibleComponent
        header={
          <div className="flex items-center gap-x-1">
            <h3 className={clsx('text-lg font-bold', css({ _pc: { fontSize: '2xl' } }))}>
              {title}
            </h3>
          </div>
        }
        defaultOpen={isGuide}
        size={size}
        color="neutral"
      >
        <div className={classes.container}>
          <div className={classes.divide}>{mainContent}</div>
          {/* プランモーダル以外では「店舗情報をもっとみる」を表示 */}
          {!isPlanModal ? (
            <>
              <Collapsible.Root open={open} onOpenChange={setOpen}>
                <Collapsible.Content
                  className={clsx(
                    classes.divide,
                    css({
                      borderTop: '[1px dashed]',
                      borderColor: 'gray.300',
                      paddingTop: '3',
                      _pc: { paddingTop: '5', borderTop: 'light' },
                    })
                  )}
                >
                  {subContent}
                </Collapsible.Content>
                <Collapsible.Trigger className="block w-full">
                  {!open && (
                    <div
                      className={hstack({
                        justifyContent: 'center',
                        color: 'link',
                        py: '1',
                        fontSize: 'sm',
                        gap: '1',
                      })}
                    >
                      もっとみる
                      <ChevronBottomOutlineIcon />
                    </div>
                  )}
                </Collapsible.Trigger>
              </Collapsible.Root>
            </>
          ) : (
            <div
              className={clsx(
                classes.divide,
                css({
                  borderTop: '[1px dashed]',
                  borderColor: 'gray.300',
                  paddingTop: '3',
                  _pc: { paddingTop: '5', borderTop: 'light' },
                })
              )}
            >
              {subContent}
            </div>
          )}
        </div>
      </CollapsibleComponent>
    </section>
  )
}
